import { Link, useNavigate } from "react-router";
import { LogOut, Mail, UserCog, UserRound } from "lucide-react";
import { useSession } from "@/lib/store/session";
import { useUser } from "@/lib/query/useUser";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const ADD_EMAIL_EVENT = "pbranks:add-email";

export function initials(name: string | null | undefined, email: string | null | undefined): string {
  const src = (name || email || "").trim();
  if (!src) return "?";
  const parts = src.split(/[\s@._-]+/).filter(Boolean);
  return parts.length >= 2 ? (parts[0]![0]! + parts[1]![0]!).toUpperCase() : src.slice(0, 2).toUpperCase();
}

export function UserMenu() {
  const navigate = useNavigate();
  const logout = useSession((s) => s.logout);
  const { data: user } = useUser();
  const name = user?.name || "Runner";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Account menu" className="rounded-full">
          <span className="flex size-8 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-fg">
            {initials(user?.name, user?.email)}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-56">
        <DropdownMenuLabel className="text-fg">
          <div className="truncate text-sm font-semibold">{name}</div>
          {user?.email ? (
            <div className="truncate text-xs font-normal text-fg-muted">{user.email}</div>
          ) : (
            <div className="text-xs font-normal text-fg-muted">No email set</div>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/account">
            <UserRound /> Account
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => window.dispatchEvent(new CustomEvent(ADD_EMAIL_EVENT))}>
          <Mail /> {user?.email ? "Change email" : "Add email"}
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/impersonate">
            <UserCog /> Impersonate
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          destructive
          onSelect={() => {
            logout();
            navigate("/auth");
          }}
        >
          <LogOut /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
